import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import SEOHead from '../components/SEO/SEOHead';

const NotFoundPage = () => {
  const { isAuthenticated } = useAuth();
  const { t } = useTranslation('common');

  return (
    <>
      <SEOHead
        title={t('notFound.title')}
        description={t('notFound.message')}
        canonical="/"
        noindex
      />
    <Container className="py-5 text-center">
      <h1 className="display-1">{t('notFound.title')}</h1>
      <h2 className="mb-4">{t('notFound.heading')}</h2>
      <p className="lead mb-4">{t('notFound.message')}</p>
      <Link to={isAuthenticated ? '/dashboard' : '/'}>
        <Button variant="primary">
          {isAuthenticated ? t('notFound.backToDashboard') : t('notFound.backToHome')}
        </Button>
      </Link>
    </Container>
    </>
  );
};

export default NotFoundPage;

